import { createContext, useContext, useMemo } from 'react';

import { type AuthenticationIds } from 'hb-builder/types/config/AuthenticationIds';

const ApiContext = createContext<
  | {
      authenticationIds: AuthenticationIds;
      routes: Record<string, unknown>;
    }
  | undefined
>(undefined);

export const ApiContextProvider = ({ authenticationIds, children, routes }) => {
  const value = useMemo(
    () => ({
      authenticationIds,
      routes,
    }),
    [authenticationIds, routes],
  );

  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
};

export const useApi = () => {
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error('useApi must be used within a ApiContextProvider');
  }

  return context;
};
